import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { StackScreen } from "@life-line-lab/components-react";
import { Helmet } from "react-helmet";
import { useSession } from "Hooks/index";
import { OrderSettingsEnum } from "Data/settings";
import { getEnumOfOrderSettings } from "Helpers/order-settings-helper";
import useOrderSettingsEdit from "../use-order-settings-edit";

const OrderProcessingSettingsEditForm = () => {
  const { org } = useSession();
  const history = useHistory();
  const { t } = useTranslation();

  const {
    expandedWidth,
    type,
    id,
    activeComponent,
    setActiveComponent,
    orderSettingState,
    setOrderSettingState,
    permission,
    handleFetchOrderSettingsList,
    handleFetchOrderSettings,
  } = useOrderSettingsEdit({ isEdit: true });

  const handleCloseStackScreen = () => {
    history.goBack();
  };

  useEffect(() => {
    handleFetchOrderSettings();

    return () =>
      setOrderSettingState((prev) => ({
        ...prev,
        data: {},
        status: { ...prev.status, fetch: "idle" },
      }));
  }, []);

  return (
    <StackScreen
      title={
        <div>
          <img
            alt={t("alt.logo")}
            src="/assets/images/banner_logo.png"
            height={30}
          />
        </div>
      }
      isOpen={true}
      renderHeader={<div></div>}
      onClose={handleCloseStackScreen}
      className={
        expandedWidth.includes(getEnumOfOrderSettings(type)) ? "rate-table" : ""
      }
    >
      <Helmet>
        <title></title>
      </Helmet>
      {activeComponent}
    </StackScreen>
  );
};

export default OrderProcessingSettingsEditForm;
